module.exports = __webpack_public_path__ + "static/media/Swanna_gaussian2.289961a9.png";